/**
 * Authentication Flow Types
 *
 * ORY INTEGRATION: Types for auth flow methods and states
 */
export var AuthFlowMethod;
(function (AuthFlowMethod) {
    AuthFlowMethod["EmailOTP"] = "email-otp";
    AuthFlowMethod["Passkey"] = "passkey";
})(AuthFlowMethod || (AuthFlowMethod = {}));
export var AuthMethodStatus;
(function (AuthMethodStatus) {
    AuthMethodStatus["Available"] = "available";
    AuthMethodStatus["Required"] = "required";
    AuthMethodStatus["Optional"] = "optional";
    AuthMethodStatus["Unavailable"] = "unavailable";
})(AuthMethodStatus || (AuthMethodStatus = {}));
// WebAuthn types removed - using only passkeys and email OTP 
